<template>
  <CockpitDialog
    class="fixed top-200px left-500px w-800px h-600px"
    v-if="visible"
    :title="title + '员工危害应知卡'"
    @close="close"
  >
    <div class="w-full h-full">
      <div class="w-full h-full relative z-9999">
        <el-table
          :data="equipDataList"
          class="w-full"
          :height="tableHeight"
          v-loading="equipTableLoading"
          @cell-click="(row) => handleView(row)"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="岗位名称"
            prop="postName"
            width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="编号"
            prop="postNum"
            width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="警示标识" prop="warningSignStr" width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="标志图片" prop="warningSignPicture" width="120">
            <template slot-scope="scope">
              <div class="min-h-110px">
                <TableImg
                  v-model="scope.row.warningSignPicture"
                  :upload-width="110"
                  :upload-height="110"
                ></TableImg>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="应急电话"
            prop="emergencyTelephone"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="主管单位" prop="competentUnit" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="主要负责人"
            prop="principalChargePerson"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="现场负责人" prop="fieldManager" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" @click.native="handleView(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <!-- <div slot="empty" class="w-full h-full flex justify-center items-center">
            <img src="../../../assets/images/no_data@1x.png" alt="" />
          </div> -->
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="equipTotalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <CockpitDialog
      class="fixed top-200px left-500px w-900px h-600px !z-10000"
      v-if="detailVisible"
      :title="'查看员工危害应知卡'"
      @close="detailVisible = false"
    >
      <div class="w-full h-full relative z-10000 overflow-y-auto">
        <div class="pdf-panel px-10px pt-20px" ref="card">
          <div class="w-full text-3xl text-center h-60px leading-60px bg-color-primary">
            员工危害性应知卡
          </div>
          <div class="table-form border-1 border-color-default">
            <table class="table-body w-full">
              <tr class="border-b-1 bg-table-header">
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary">
                    岗位名称
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.postName }}</div>
                </td>

                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>编号</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.postNum }}</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>风险等级</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.riskLevelStr }}</div>
                </td>
              </tr>
              <tr class="border-b-1 bg-white">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>工作关联风险区域</div>
                </td>
                <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary font-normal">
                    {{ formData.jobAssociatedRiskAreaStr }}
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 bg-table-header">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>风险警示标识</div>
                </td>
                <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary font-normal">
                    {{ formData.warningSignStr }}
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 bg-white">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>警示区域图标</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell ">
                  <div class="flex justify-center items-center" v-if="formData.fileList.length > 0">
                    <el-image
                      fit="contain"
                      class="w-104px h-85px"
                      :src="formData.fileList[0].imgContent"
                      alt=""
                    />
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div class="flex justify-center items-center" v-if="formData.fileList.length > 1">
                    <el-image
                      fit="contain"
                      class="w-104px h-85px"
                      :src="formData.fileList[1].imgContent"
                      alt=""
                    />
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div class="flex justify-center items-center" v-if="formData.fileList.length > 2">
                    <el-image
                      fit="contain"
                      class="w-104px h-85px"
                      :src="formData.fileList[2].imgContent"
                      alt=""
                    />
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div class="flex justify-center items-center" v-if="formData.fileList.length > 3">
                    <el-image
                      fit="contain"
                      class="w-104px h-85px"
                      :src="formData.fileList[3].imgContent"
                      alt=""
                    />
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div class="flex justify-center items-center" v-if="formData.fileList.length > 4">
                    <el-image
                      fit="contain"
                      class="w-104px h-85px"
                      :src="formData.fileList[4].imgContent"
                      alt=""
                    />
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 bg-table-header">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>危险有害因素</div>
                </td>
                <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.dangerousHarmfulFactors }}</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>风险管控措施</div>
                </td>
                <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.riskControlMeasures }}</div>
                </td>
              </tr>
              <tr class="border-b-1 bg-white">
                <td class="w-1/6 border-r-1  p-10px table-cell">
                  <div>应急处置措施</div>
                </td>
                <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                  <div
                    v-for="(item, index) in emergencyMeasuresMap(formData.emergencyMeasures)"
                    :key="index"
                  >
                    {{ index + 1 }}、{{ item }}
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>应急电话</div>
                </td>
                <td colspan="2" class=" w-1/6 border-r-1  p-10px table-cell">
                  <div
                    v-for="(item, index) in emergencyTelephoneMap(formData.emergencyTelephone)"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </td>
              </tr>
              <tr class="border-b-1 bg-table-header">
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div class="text-color-primary">
                    主管单位
                  </div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.competentUnit }}</div>
                </td>

                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>主要负责人</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.principalChargePerson }}</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>现场负责人</div>
                </td>
                <td class=" w-1/6 border-r-1  p-10px table-cell">
                  <div>{{ formData.fieldManager }}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </CockpitDialog>
  </CockpitDialog>
</template>

<script>
import { EmployeesHazardCharacteristicsCardApi } from '@wiz-api/double-prevention-management'
import { FileApi } from '@wiz-api/file-management'
import CockpitDialog from '../../../../../components/cockpit/CockpitDialog'
import TableImg from './components/TableImg'

const employeesHazardCharacteristicsCardApi = new EmployeesHazardCharacteristicsCardApi()
const fileApi = new FileApi()

export default {
  name: 'employee-card-list',
  components: {
    CockpitDialog,
    TableImg,
  },
  props: {
    areaId: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: true,
      detailVisible: false,
      formData: {
        postName: '',
        postNum: '',
        jobAssociatedRiskAreaStr: '',
        riskLevel: null,
        warningSigns: null,
        warningSignPicture: '',
        dangerousHarmfulFactors: '',
        riskControlMeasures: '',
        emergencyMeasures: '',
        emergencyTelephone: '',
        competentUnit: '',
        principalChargePerson: '',
        fieldManager: '',
        annex: undefined,
        jobAssociatedRiskAreasIds: [],
        warningSignsIds: [],
        warningSignStr: '',
        riskLevelStr: '',
        fileList: [],
      },
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        ownedUnitId: '',
        areaId: this.areaId,
        evaluationLevel: '',
        riskPointType: 0,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 60px)'
    },
    emergencyMeasuresMap() {
      return (val) => {
        const splitStr = val.indexOf(';') > -1 ? ';' : '；'
        const valArr = val.split(splitStr)
        return _.filter(valArr, (ele) => {
          return ele
        })
      }
    },
    emergencyTelephoneMap() {
      return (val) => {
        const splitStr = val.indexOf(';') > -1 ? ';' : '；'
        const valArr = val.split(splitStr)
        return _.filter(valArr, (ele) => {
          return ele
        })
      }
    },
  },
  mounted() {
    this.getEquipList()
  },
  methods: {
    async handleView(row) {
      this.formData = this.$options.data().formData
      const [err, res] = await employeesHazardCharacteristicsCardApi.get(row.id)
      if (!err) {
        this.formData = {
          ...this.formData,
          ...res,
        }
        this.getImgContent(this.formData.warningSignPicture.split(','))
        this.detailVisible = true
      }
    },

    async getImgContent(fileId) {
      const promiseList = []
      fileId.forEach((id) => {
        promiseList.push(fileApi.getFileContent(id))
      })
      const imgList = []
      Promise.all(promiseList).then((list) => {
        list.forEach((item, index) => {
          const [err, res] = item
          if (!err) {
            const file = {
              id: fileId[index],
              imgContent: `data:image/jpg;base64,${res.content}`,
            }
            imgList.push(file)
          }
        })
        this.formData.fileList = imgList
      })
    },
    // 切换查询
    changeValues(values) {
      this.handleSearch()
    },
    // 关闭弹窗
    close() {
      this.$emit('cancel')
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
        jobAssociatedRiskAreas: [this.areaId],
      }
      this.equipTableLoading = true

      const [err, res] = await employeesHazardCharacteristicsCardApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/styles/filterSelect.scss';
</style>
<style scoped lang="scss">
@import '../../../assets/styles/input.scss';
@import '../../../assets/styles/table.scss';
@import '../../../assets/styles/pagination.scss';
@import '../../../assets/styles/shadow.scss';
@import '../../../assets/styles/button.scss';
@import '../../../assets/styles/dialog.scss';
@import '../../../assets/styles/loading.scss';

::v-deep .round-button {
  line-height: 1;
}
::v-deep .el-button {
  background-image: var(--cockpitButtonBg) !important;
}
::v-deep .el-input__inner {
  border: none;
}
// ::v-deep .el-table__empty-text {
//   display: block;
//   height: 100%;
//   width: 100%;
// }
.table-form {
  td:last-child {
    border-right: none;
  }
  .table-body {
    word-break: break-all;
    font-size: 14px;
    tr:last-child {
      border: none;
    }
    td:first-child {
      border-left: none;
    }
  }

  ::v-deep .el-card .el-card__header {
    padding: 10px;
  }

  ::v-deep .custom-card {
    border-bottom: none !important;
  }

  ::v-deep .el-card .el-card__header {
    padding: 0 !important;
  }
}
</style>
